module.exports = __webpack_public_path__ + "static/media/fly0197.b8ad12e9.webp";